import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareArrowBottomLeftCorner: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-arrow-bottom-left-corner"} maskId="square-filled-radius-0-stroke-1-IconSquareArrowBottomLeftCorner"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7 16.293V11H6V18H13V17H7.70703L13.707 11L13 10.293L7 16.293Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquareArrowBottomLeftCorner;
